


import { Routes, RouterModule } from '@angular/router';
import { PermissionComponent } from './permission.component';

const routes: Routes = [
    {
        path: '',
        component: PermissionComponent
    },
];

export const PermissionRoutes = RouterModule.forChild(routes);
